import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[re-autofocus]',
    standalone: false
})
export class AutofocusDirective {

  constructor(private el: ElementRef) {
    setTimeout(() => {
      (<HTMLOrSVGElement>el.nativeElement).focus();
    });
  }

}
